<hr
  class="h-[1px] border-none"
  style:background={"radial-gradient(rgba(255, 255, 255, 0.3) 20%, transparent 65%)"}
/>
